import { render, staticRenderFns } from "./IdTagTable.vue?vue&type=template&id=87b37586&"
import script from "./IdTagTable.vue?vue&type=script&lang=ts&"
export * from "./IdTagTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports